import { render, staticRenderFns } from "./mobile-nav-template.vue?vue&type=template&id=96bf8260&"
import script from "./mobile-nav-template.vue?vue&type=script&lang=ts&"
export * from "./mobile-nav-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports